"use client";

import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import * as React from "react";

import { css } from "../../../styled-system/css";

const tooltip = {
  zIndex: "50",
  overflow: "hidden",
  rounded: "lg",
  px: "3",
  py: "2",
  fontSize: "xs",
  lineHeight: "tight",
  color: "white",
  backgroundColor: "gray.900",
  textAlign: "center",
  animateIn: true,
  fadeIn: 0,
  zoomIn: 95,
  "&[data-state=closed]": {
    animateOut: true,
    fadeOut: 0,
    zoomOut: 95,
  },
  "&[data-side=top]": {
    slideInFromBottom: "2",
  },
  "&[data-side=bottom]": {
    slideInFromTop: "2",
  },
  "&[data-side=left]": {
    slideInFromRight: "2",
  },
  "&[data-side=right]": {
    slideInFromLeft: "2",
  },
};

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    css?: object;
  }
>(({ sideOffset = 4, css: cssProp = {}, ...props }, ref) => {
  const className = css(tooltip, cssProp);

  return (
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={className}
      {...props}
    />
  );
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
